import { SetterOrUpdater, atom } from 'recoil';

export interface ModalModifyBillDataType {
  visible: boolean;
  pkid: number;
  uname: string;
  rname: string;
  startdate: string;
  payment_period: number;
  content: string;
  amount: number;
  phone: string;
  upcheck: string;
  uid: number;
  member_id: string;
  status?: string | null;
  callback: () => Promise<void>;
}

export const modalModifyBillData = atom<ModalModifyBillDataType>({
  key: 'modalModifyBill',
  default: {
    visible: false,
    pkid: 0,
    uname: '',
    rname: '',
    startdate: '',
    payment_period: 0,
    content: '',
    amount: 0,
    phone: '',
    upcheck: '',
    uid: 0,
    member_id: '',
    status: '',
    callback: async () => {
      return;
    },
  },
});

interface ModalModifyBillSetter {
  setModalModifyBill: SetterOrUpdater<ModalModifyBillDataType>;
}

export const openModalModifyBill = (
  { setModalModifyBill }: ModalModifyBillSetter,
  options: Omit<ModalModifyBillDataType, 'visible'>,
) => {
  setModalModifyBill(prev => ({
    ...prev,
    visible: true,
    ...options,
  }));
};

export const closeModalModifyBill = ({ setModalModifyBill }: ModalModifyBillSetter) => {
  setModalModifyBill({
    visible: false,
    pkid: 0,
    uname: '',
    rname: '',
    startdate: '',
    payment_period: 0,
    content: '',
    amount: 0,
    phone: '',
    upcheck: '',
    uid: 0,
    member_id: '',
    callback: async () => {
      return;
    },
  });
};
